import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { ShopProvider } from "@/context/ShopContext";
import { AdminProvider } from "@/context/AdminContext";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CartDrawer from "@/components/site/CartDrawer";
import SearchOverlay from "@/components/site/SearchOverlay";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import OrderLookup from "@/pages/OrderLookup";
import PaymentCancel from "@/pages/PaymentCancel";
import Reviews from "@/pages/Reviews";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Policy from "@/pages/Policy";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function StoreShell() {
  return (
    <ShopProvider>
      <ScrollToTop />
      <Header />
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment/success" element={<OrderConfirmation />} />
          <Route path="/track-order" element={<OrderLookup />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/policies/:kind" element={<PolicyWrapper />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer />
      <SearchOverlay />
    </ShopProvider>
  );
}

function PolicyWrapper() {
  const { pathname } = useLocation();
  const kind = pathname.split("/").pop();
  return <Policy key={kind} kind={kind} />;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App bg-[#080808] min-h-screen">
      <BrowserRouter>
        <AdminProvider>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminLayout />} />
            <Route path="/*" element={<StoreShell />} />
          </Routes>
        </AdminProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid rgba(212,175,55,0.3)",
            borderLeft: "3px solid #D4AF37",
            color: "#fff",
            borderRadius: "2px",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
